module.exports = __webpack_public_path__ + "img/airport.50086bd2.svg";